module.exports = __webpack_public_path__ + "static/media/bg-booking.33ad73f7.svg";